import { render, staticRenderFns } from "./RoomHelp.vue?vue&type=template&id=5cfc4948"
import script from "./RoomHelp.vue?vue&type=script&lang=js"
export * from "./RoomHelp.vue?vue&type=script&lang=js"
import style0 from "./RoomHelp.vue?vue&type=style&index=0&id=5cfc4948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports